import { render, staticRenderFns } from "./DefectForm.vue?vue&type=template&id=796ab627&scoped=true"
import script from "./DefectForm.vue?vue&type=script&lang=js"
export * from "./DefectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ab627",
  null
  
)

export default component.exports